import React from 'react'
import Header from '../../components/header/Header'

const Notice = () => {
  return (
    <div>
      <Header/>
    </div>
  )
}

export default Notice;